import React, { Suspense } from 'react';
import styled, { css } from 'styled-components';
import { ErrorBoundary } from '@sparknz/journeys-common';

import ProductDetailsNoAccountModalProvider from 'journey/productDetails/components/ProductDetailsNoAccountModalProvider';
import {
  DeviceOfferDetail,
  PrimaryCategory,
} from 'journey/productDetails/typings';
import { useSegment } from 'shared/hooks';
import { PLANS_ID, PRICING_ID } from '../../../constants';
import AddToCartSection from '../../AddToCartSection';
import PaymentOptions from '../../PaymentOptions';
import PlanOptions from '../../PlanOptions';
import { OptionsLoader } from '../../ProductConfiguratorLoader';
import ProductDeals from '../../ProductDeals';
import TradeInSection from '../../TradeInSection';
import ProductOrderActionLayer from './ProductOrderActionLayer';
import ProductOrderConfiguratorError from './ProductOrderConfiguratorError';

// TODO: export this from pattern library
const HEADER_WITH_SEGMENT_SWITCHER_HEIGHT = 120;

const ScrollTarget = styled.div`
  ${({ theme: { spacing, media } }) => css`
    scroll-margin-top: ${spacing.s3};
    ${media.up('big')} {
      scroll-margin-top: ${HEADER_WITH_SEGMENT_SWITCHER_HEIGHT}px;
    }
  `}
`;

interface ProductOrderConfiguratorProps {
  primaryCategory: DeviceOfferDetail['primaryCategory'];
}

export default function ProductOrderConfigurator({
  primaryCategory,
}: ProductOrderConfiguratorProps) {
  const { isPersonal, isLargeBusiness } = useSegment();
  const isMobileDevice = primaryCategory.id === PrimaryCategory.HANDSET;
  const shouldShowTradeInSection = isMobileDevice && isPersonal;

  return (
    <ErrorBoundary fallback={() => <ProductOrderConfiguratorError />}>
      <Suspense fallback={<OptionsLoader />}>
        <ScrollTarget id={PRICING_ID}>
          <PaymentOptions />
          <ProductDeals />
        </ScrollTarget>
      </Suspense>
      {isLargeBusiness ? null : (
        <Suspense fallback={<OptionsLoader />}>
          <ScrollTarget id={PLANS_ID}>
            <PlanOptions />
          </ScrollTarget>
        </Suspense>
      )}
      {shouldShowTradeInSection ? (
        <ErrorBoundary fallback={() => null}>
          <Suspense fallback={<OptionsLoader />}>
            <TradeInSection />
          </Suspense>
        </ErrorBoundary>
      ) : null}
      <Suspense fallback={<OptionsLoader />}>
        <ProductDetailsNoAccountModalProvider>
          <AddToCartSection />
          <ProductOrderActionLayer />
        </ProductDetailsNoAccountModalProvider>
      </Suspense>
    </ErrorBoundary>
  );
}
